// Google sign-in page — renders the sign-in button and links to Privacy Policy and
// Terms of Service at their dedicated routes.

import React from 'react';

function Login({ onSignIn }) {
    return (
        <div className="flex items-center justify-center min-h-screen bg-[var(--color-light)]">
            <div className="p-10 bg-[color:var(--surface-primary)] rounded-lg shadow-xl text-center">
                <img
                    src="/images/keyflow-logo.generated.svg"
                    alt="KeyFlow"
                    className="h-16 mx-auto mb-4"
                />
                <h1 className="text-2xl font-bold text-[color:var(--text-secondary)] mb-2">KeyFlow</h1>
                <p className="text-[color:var(--text-muted)] mb-8">Keep your clients informed without the extra work.</p>
                <button
                    onClick={onSignIn}
                    className="bg-[var(--color-accent)] hover:opacity-90 text-[color:var(--on-accent)] font-bold py-2 px-4 rounded-lg flex items-center justify-center mx-auto transition-opacity"
                >
                    <svg className="w-6 h-6 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
                        <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039L38.802 8.94C34.323 4.982 28.808 3 24 3C12.954 3 4 11.954 4 23s8.954 20 20 20s20-8.954 20-20c0-1.341-.138-2.65-.389-3.917z" />
                        <path fill="#FF3D00" d="M6.306 14.691c-1.328 2.35-2.131 5.12-2.131 8.13s.803 5.78 2.131 8.13l-5.305 4.14C.947 31.64 0 27.48 0 23s.947-8.64 2.63-12.14l5.305 4.14z" />
                        <path fill="#4CAF50" d="M24 43c5.166 0 9.86-1.977 13.409-5.192l-5.305-4.14C29.86 36.023 27.12 37 24 37c-5.202 0-9.619-3.317-11.283-7.946l-5.305 4.14C9.372 39.023 16.14 43 24 43z" />
                        <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.087 5.571l5.305 4.14C42.051 35.1 44 30.023 44 23c0-1.341-.138-2.65-.389-3.917z" />
                    </svg>
                    Sign in with Google
                </button>
                <div className="mt-8 text-sm text-[color:var(--text-muted)]">
                    <a href="https://keyflow.homes/terms" target="_blank" rel="noopener noreferrer" className="underline hover:opacity-80">Terms of Service</a>
                    <span className="mx-2">|</span>
                    <a href="https://keyflow.homes/privacy" target="_blank" rel="noopener noreferrer" className="underline hover:opacity-80">Privacy Policy</a>
                </div>
            </div>
        </div>
    );
}

export default Login;
